import {Avatar, Link} from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Unstable_Grid2';
import {useTranslation} from 'react-i18next';
import {useProfile} from '../../context/ProfileContext';
import {useRouter} from '../../context/RouterContext';
import {AvatarIcon} from "../../utils/assets/AvatarIcon";
import {Stack} from '@mui/system';

export const Header = () => {
    const {t} = useTranslation();
    const {navigate} = useRouter();
    const {profile, printDisplayName} = useProfile();

    const goTo = (url: string, setReturnUrl: boolean = false) => {
        navigate(url, setReturnUrl);
    }

    const onLogo = (e: React.MouseEvent<HTMLElement>) => {
        goTo('/');
        e.preventDefault();
    }
    const onProfile = () => goTo('/profile')

    return (
        <AppBar position="relative" className="topBar">
            <Container maxWidth={false} sx={{px: 0.5}}>
                <Toolbar disableGutters>

                    {/* Main container */}
                    <Stack width={'100%'} margin={'auto'} gap={3}
                           direction={'row'} justifyContent={'space-between'} flexWrap={'nowrap'}
                           alignContent={'center'} alignItems={'center'}>

                        {/* Left part */}
                        <Link href="/" onClick={onLogo} color={'inherit'} underline={'none'} sx={{cursor: 'pointer'}}>
                            <Stack direction={'row'} alignItems={'center'} gap={1}>
                                <img alt="TCS Logo" width="48" height="48" className="img-contain"
                                     src="/images/tcslogo.webp"/>
                                <h1 className="app-title">{t('app_name')}</h1>
                            </Stack>
                        </Link>

                        {/* Right part */}
                        <Stack direction={'row'} justifyItems={'center'} alignItems={'center'} gap={1} pt={1.5} pb={1}>
                            <Grid container gap={1}>
                                {profile && (
                                    <IconButton sx={{p: 0}} onClick={onProfile}>
                                        <Avatar
                                            alt={profile ? printDisplayName(profile?.publicProfile) : ''}
                                            src={profile ? AvatarIcon.forAvatar(profile?.publicProfile.avatar) : ''}></Avatar>
                                    </IconButton>
                                )}
                            </Grid>
                        </Stack>
                        {/* </Grid> */}
                    </Stack>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

